import React from "react";
import { Eye, X } from "lucide-react";

const formatList = (values = []) => {
    if (!values || values.length === 0) return "-";
    return values.join(", ");
};

function RepertoireDetailsModal({ open, onClose, repertoire }) {
    if (!open || !repertoire) return null;

    return (
        <div className="rep-overlay" onMouseDown={onClose}>
            <div className="rep-modal rep-modal--wide" onMouseDown={(event) => event.stopPropagation()}>
                <div className="rep-modal__header">
                    <div className="rep-modal__title">
                        <Eye size={16} style={{ color: "#ee645f" }} />
                        Details - {repertoire.name}
                    </div>

                    <button type="button" className="rep-icon-btn" onClick={onClose}>
                        <X size={15} />
                    </button>
                </div>

                <div className="rep-modal__body">
                    <div className="rep-view-grid">
                        <div className="rep-view-item">
                            <span className="rep-view-label">Code</span>
                            <span className="rep-view-value">{repertoire.code || "-"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Nom</span>
                            <span className="rep-view-value">{repertoire.name || "-"}</span>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Description</span>
                            <span className="rep-view-value">{repertoire.description || "-"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Statut</span>
                            <span className="rep-view-value">{repertoire.status || "-"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Parent ID</span>
                            <span className="rep-view-value">{repertoire.parentId || "-"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Nombre d'enfants</span>
                            <span className="rep-view-value">{repertoire.childrenCount || 0}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Filter mode</span>
                            <span className="rep-view-value">{repertoire.filterMode || "IN"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Niveau manager</span>
                            <span className="rep-view-value">{repertoire.managerLevelFilter || "-"}</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Population cible</span>
                            <span className="rep-view-value">{repertoire.targetUserCount || 0} utilisateur(s)</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Permissions affectees</span>
                            <span className="rep-view-value">{repertoire.userPermissions?.length || 0} utilisateur(s)</span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Cree le</span>
                            <span className="rep-view-value">
                                {repertoire.createdAt
                                    ? new Date(repertoire.createdAt).toLocaleString("fr-FR")
                                    : "-"}
                            </span>
                        </div>

                        <div className="rep-view-item">
                            <span className="rep-view-label">Modifie le</span>
                            <span className="rep-view-value">
                                {repertoire.updatedAt
                                    ? new Date(repertoire.updatedAt).toLocaleString("fr-FR")
                                    : "-"}
                            </span>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Entites filtrees</span>
                            <span className="rep-view-value">{formatList(repertoire.entiteIds)}</span>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Postes filtres</span>
                            <span className="rep-view-value">{formatList(repertoire.posteIds)}</span>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Utilisateurs explicitement cibles</span>
                            <span className="rep-view-value">{formatList(repertoire.userIds)}</span>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Utilisateurs autorises</span>
                            <div className="rep-chip-list" style={{ marginTop: 8 }}>
                                {repertoire.authorizedUsers?.length ? (
                                    repertoire.authorizedUsers.map((user) => (
                                        <span key={user.id} className="rep-chip">
                                            {user.fullName || `${user.firstName || ""} ${user.lastName || ""}`}
                                        </span>
                                    ))
                                ) : (
                                    <span className="rep-muted">Aucun</span>
                                )}
                            </div>
                        </div>

                        <div className="rep-view-item rep-view-item--full">
                            <span className="rep-view-label">Matrice de permissions</span>
                            <div className="rep-permissions-table-wrap" style={{ marginTop: 8 }}>
                                <table className="rep-permissions-table">
                                    <thead>
                                    <tr>
                                        <th>Utilisateur</th>
                                        <th>Consulter</th>
                                        <th>Créer</th>
                                        <th>Valider</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {repertoire.userPermissions?.length ? (
                                        repertoire.userPermissions.map((permission) => (
                                            <tr key={permission.userId || permission.id}>
                                                <td>{permission.fullName || "" }</td>
                                                <td>{permission.canConsult ? "Oui" : "Non"}</td>
                                                <td>{permission.canCreate ? "Oui" : "Non"}</td>
                                                <td>{permission.canValidate ? "Oui" : "Non"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="rep-empty-cell">
                                                Aucune permission utilisateur definie
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rep-modal__footer">
                    <button type="button" className="rep-btn rep-btn--ghost" onClick={onClose}>
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RepertoireDetailsModal;


